import { gql } from '@apollo/client'
import { CheckIcon, Chip, ChipClickable, Dropdown, MenuItem } from '@farol-ds/react'
import classNames from 'classnames'

import { DropdownOffers_OfferLockCardFragment } from './__generated__/dropdown-offers.graphql'
import styles from './dropdown-offers.module.scss'

interface DropdownOffersProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onPlanChange: (planTitle: string) => void
  offerLockCard: DropdownOffers_OfferLockCardFragment[]
  selectedPlanOffer?: DropdownOffers_OfferLockCardFragment | null
}

export const DropdownOffers = ({
  isOpen,
  offerLockCard,
  selectedPlanOffer,
  onOpenChange,
  onPlanChange,
}: DropdownOffersProps) => {
  return (
    <Dropdown open={isOpen} onOpenChange={onOpenChange}>
      <Dropdown.Trigger asChild>
        <ChipClickable
          selected
          chevron
          leftIcon={<CheckIcon />}
          onClick={() => onOpenChange(!isOpen)}
          size="lg"
        >
          Plano {selectedPlanOffer?.title}
        </ChipClickable>
      </Dropdown.Trigger>

      <Dropdown.Menu side="bottom" placement="start">
        {offerLockCard.map((plan) => {
          const isSelected = plan.title === selectedPlanOffer?.title
          const discountText = plan?.offer?.discountText

          return (
            <Dropdown.MenuItem key={plan.title} onSelect={() => onPlanChange(plan.title)}>
              <MenuItem className={classNames(styles.item, { [styles.selected]: isSelected })}>
                <MenuItem.Content>Plano {plan.title}</MenuItem.Content>

                {discountText && (
                  <Chip size="sm" kind="secondary" className={styles.itemChip}>
                    <b>até {discountText}</b>
                  </Chip>
                )}

                {isSelected && <CheckIcon size="sm" />}
              </MenuItem>
            </Dropdown.MenuItem>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

DropdownOffers.fragments = {
  offerLockCard: gql`
    fragment DropdownOffers_offerLockCard on OfferLockCard {
      title
      offer {
        discountText
      }
    }
  `,
}
